export default __webpack_public_path__ + "static/media/motivations.cc3374a5.mp3";